export const mockGetAirportListData = [
  {
    country: 'Brasil',
    altitude: '14',
    code: 'CFB',
    city: 'Rio de Janeiro',
    congenere: 'false',
    timezone: 'America/Sao_Paulo',
    latitude: '-22.92168',
    active: 'true',
    description: 'Rio de Janeiro, Brasil, Cabo Frio (CFB) [Rio de Janeiro] ',
    g3: 'true',
    mac: 'RIO',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Cabo Frio',
    location: { lon: '-42.074268', lat: '-22.92168' },
    state: 'Rio de Janeiro',
    international: 'false',
    longitude: '-42.074268',
  },
  {
    country: 'Brasil',
    altitude: '11',
    code: 'SDU',
    city: 'Rio de Janeiro',
    congenere: 'false',
    timezone: 'America/Sao_Paulo',
    latitude: '-22.910461',
    active: 'true',
    description: 'Rio de Janeiro, Brasil, Santos Dumont (SDU) [Rio de Janeiro] ',
    g3: 'true',
    mac: 'RIO',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Santos Dumont',
    location: { lon: '-43.163133', lat: '-22.910461' },
    state: 'Rio de Janeiro',
    international: 'false',
    longitude: '-43.163133',
  },
  {
    country: 'Brasil',
    altitude: '0',
    code: 'RIO',
    city: 'Rio de Janeiro',
    congenere: 'true',
    timezone: 'America/Sao_Paulo',
    latitude: '0',
    active: 'true',
    description: 'Rio de Janeiro, Brasil, Todos os Aeroportos (RIO) [Rio de Janeiro] ',
    g3: 'true',
    mac: 'RIO',
    iata: 'GIG',
    zone: 'América do Sul',
    name: 'Todos os Aeroportos',
    location: { lon: '0', lat: '0' },
    state: 'Rio de Janeiro',
    international: 'true',
    longitude: '0',
  },
  {
    country: 'Brasil',
    altitude: '28',
    code: 'GIG',
    city: 'Rio de Janeiro',
    congenere: 'true',
    timezone: 'America/Sao_Paulo',
    latitude: '-22.808903',
    active: 'true',
    description: 'Rio de Janeiro, Brasil, Galeao/Antonio Carlos Jobim   (GIG) [Rio de Janeiro] ',
    g3: 'true',
    mac: 'RIO',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Galeão/Antonio Carlos Jobim  ',
    location: { lon: '-43.243647', lat: '-22.808903' },
    state: 'Rio de Janeiro',
    international: 'true',
    longitude: '-43.243647',
  },
  {
    country: 'Brasil',
    altitude: '105',
    code: 'TXF',
    city: 'Teixeira de Freitas',
    congenere: 'false',
    timezone: 'America/Recife',
    latitude: '-17.52473',
    active: 'true',
    description: 'Teixeira de Freitas, Brasil (TXF) [Teixeira de Freitas] ',
    g3: 'true',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Teixeira de Freitas Airport',
    location: { lon: '-39.66983', lat: '-17.52473' },
    state: 'Bahia',
    international: 'false',
    longitude: '-39.66983',
  },
  {
    country: 'Espanha',
    altitude: '93',
    code: 'XRY',
    city: 'Jerez de la Frontera',
    congenere: 'true',
    timezone: 'Europe/Madrid',
    latitude: '36.744622',
    active: 'true',
    description: 'Jerez de la Frontera, Espanha (XRY) [Jerez de la Frontera] ',
    g3: 'false',
    iata: 'Europa',
    zone: 'Europa',
    name: 'Jerez',
    location: { lon: '-6.060111', lat: '36.744622' },
    state: null,
    international: 'true',
    longitude: '-6.060111',
  },
  {
    country: 'Canadá',
    altitude: '35',
    code: 'YGR',
    city: 'Îles de la Madeleine',
    congenere: 'true',
    timezone: 'America/Halifax',
    latitude: '47.424721',
    active: 'true',
    description: 'Iles de la Madeleine, Canada (YGR) [Iles de la Madeleine] ',
    g3: 'false',
    iata: 'América do Norte',
    zone: 'América do Norte',
    name: ' ÎlesdelaMadeleine Airport',
    location: { lon: '-61.778056', lat: '47.424721' },
    state: null,
    international: 'true',
    longitude: '-61.778056',
  },
  {
    country: 'Cuba',
    altitude: '249',
    code: 'SCU',
    city: 'Santiago De Cuba',
    congenere: 'true',
    timezone: 'America/Havana',
    latitude: '19',
    active: 'true',
    description: 'Santiago De Cuba, Cuba (SCU) [Santiago De Cuba] ',
    g3: 'false',
    iata: 'América do Norte',
    zone: 'América do Norte',
    name: 'Antonio Maceo Intl',
    location: { lon: '-75', lat: '19' },
    state: null,
    international: 'true',
    longitude: '-75',
  },
  {
    country: 'Martinica',
    altitude: '16',
    code: 'FDF',
    city: 'Fort de France',
    congenere: 'true',
    timezone: 'America/Martinique',
    latitude: '14.591033',
    active: 'true',
    description: 'Fort de France, Martinica (FDF) [Fort de France] ',
    g3: 'false',
    iata: 'América Central',
    zone: 'América Central',
    name: 'Martinique Aimé Césaire',
    location: { lon: '-61.003175', lat: '14.591033' },
    state: null,
    international: 'true',
    longitude: '-61.003175',
  },
  {
    country: 'Espanha',
    altitude: '1213',
    code: 'SCQ',
    city: 'Santiago de Compostela',
    congenere: 'true',
    timezone: 'Europe/Madrid',
    latitude: '42.896333',
    active: 'true',
    description: 'Santiago de Compostela, Espanha (SCQ) [Santiago de Compostela] ',
    g3: 'false',
    iata: 'Europa',
    zone: 'Europa',
    name: 'Santiago de Compostela',
    location: { lon: '-8.415144', lat: '42.896333' },
    state: null,
    international: 'true',
    longitude: '-8.415144',
  },
  {
    country: 'Espanha',
    altitude: '24',
    code: 'PMI',
    city: 'Palma de Mallorca',
    congenere: 'true',
    timezone: 'Europe/Madrid',
    latitude: '39.55361',
    active: 'true',
    description: 'Palma de Mallorca, Espanha (PMI) [Palma de Mallorca] ',
    g3: 'false',
    iata: 'Europa',
    zone: 'Europa',
    name: 'Aeroporto Son Sant Joan',
    location: { lon: '2.727778', lat: '39.55361' },
    state: null,
    international: 'true',
    longitude: '2.727778',
  },
  {
    country: 'Brasil',
    altitude: '193',
    code: 'FEN',
    city: 'Fernando de Noronha',
    congenere: 'false',
    timezone: 'America/Noronha',
    latitude: '-3.854928',
    active: 'true',
    description: 'Fernando de Noronha, Brasil (FEN) [Fernando de Noronha] ',
    g3: 'true',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Fernando de Noronha',
    location: { lon: '-32.423336', lat: '-3.854928' },
    state: 'Pernambuco',
    international: 'false',
    longitude: '-32.423336',
  },
  {
    country: 'Brasil',
    altitude: '0',
    code: 'IZA',
    city: 'Juiz de Fora',
    congenere: 'false',
    timezone: 'America/Sao_Paulo',
    latitude: '0',
    active: 'true',
    description: 'Juiz de Fora, Brasil (IZA) [Juiz de Fora] ',
    g3: 'true',
    zone: 'América do Sul',
    name: 'Francisco Álvares de Assis',
    location: { lon: '0', lat: '0' },
    state: 'Minas Gerais',
    international: 'false',
    longitude: '0',
  },
  {
    country: 'República Dominicana',
    altitude: '565',
    code: 'STI',
    city: 'Santiago de Los Cabbaleros',
    congenere: 'true',
    timezone: 'America/Santo_Domingo',
    latitude: '19.406092',
    active: 'true',
    description: 'Santiago de Los Cabbaleros, Republica Dominicana (STI) [Santiago de Los Cabbaleros] ',
    g3: 'false',
    iata: 'América Central',
    zone: 'América Central',
    name: 'Cibao',
    location: { lon: '-70.604689', lat: '19.406092' },
    state: null,
    international: 'true',
    longitude: '-70.604689',
  },
  {
    country: 'Argentina',
    altitude: '2569',
    code: 'CPC',
    city: 'San Martin de los Andes',
    congenere: 'true',
    timezone: 'America/Argentina/Salta',
    latitude: '-40.075383',
    active: 'true',
    description: 'San Martin de los Andes, Argentina (CPC) [San Martin de los Andes] ',
    g3: 'false',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'Aviador Carlos Campos',
    location: { lon: '-71.137294', lat: '-40.075383' },
    state: null,
    international: 'true',
    longitude: '-71.137294',
  },
  {
    country: 'Ilhas Reunião',
    altitude: '66',
    code: 'RUN',
    city: 'St Denis de La Reunion',
    congenere: 'true',
    timezone: 'Indian/Reunion',
    latitude: '-20.8871',
    active: 'true',
    description: 'St Denis de La Reunion, Ilhas Reuniao (RUN) [St Denis de La Reunion] ',
    g3: 'false',
    iata: 'África',
    zone: 'África',
    name: 'Roland Garros  ',
    location: { lon: '55.510308', lat: '-20.8871' },
    state: null,
    international: 'true',
    longitude: '55.510308',
  },
  {
    country: 'Espanha',
    altitude: '107',
    code: 'SPC',
    city: 'Santa Cruz de La Palma',
    congenere: 'true',
    timezone: 'Atlantic/Canary',
    latitude: '28.626478',
    active: 'true',
    description: 'Santa Cruz de La Palma, Espanha (SPC) [Santa Cruz de La Palma] ',
    g3: 'false',
    iata: 'Europa',
    zone: 'Europa',
    name: 'Lanzarote',
    location: { lon: '-17.755611', lat: '28.626478' },
    state: null,
    international: 'true',
    longitude: '-17.755611',
  },
  {
    country: 'Bolivia',
    altitude: '1225',
    code: 'VVI',
    city: 'Santa Cruz de La Sierra',
    congenere: 'true',
    timezone: 'America/La_Paz',
    latitude: '-17.644756',
    active: 'true',
    description: 'Santa Cruz de La Sierra, Bolivia (VVI) [Santa Cruz de La Sierra] ',
    g3: 'true',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'Viru Viru',
    location: { lon: '-63.135364', lat: '-17.644756' },
    state: null,
    international: 'true',
    longitude: '-63.135364',
  },
  {
    country: 'Brasil',
    altitude: '633',
    code: 'RBR',
    city: 'Rio Branco',
    congenere: 'false',
    timezone: 'America/Rio_Branco',
    latitude: '-9.583',
    active: 'true',
    description: 'Rio Branco, Brasil (RBR) [Rio Branco] ',
    g3: 'true',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Plácido de Castro',
    location: { lon: '-67.4836', lat: '-9.583' },
    state: 'Acre',
    international: 'false',
    longitude: '-67.4836',
  },
  {
    country: 'Angola',
    altitude: '243',
    code: 'LAD',
    city: 'Luanda',
    congenere: 'true',
    timezone: 'Africa/Luanda',
    latitude: '-8.86',
    active: 'true',
    description: 'Luanda, Angola (LAD) [Luanda] ',
    g3: 'false',
    iata: 'África',
    zone: 'África',
    name: 'Quatro de Fevereiro',
    location: { lon: '13.23', lat: '-8.86' },
    state: null,
    international: 'true',
    longitude: '13.23',
  },
  {
    country: 'Jordânia',
    altitude: '2555',
    code: 'ADJ',
    city: 'Amã',
    congenere: 'true',
    timezone: 'Asia/Amman',
    latitude: '32',
    active: 'true',
    description: 'Ama, Jordania, Aeroporto Civil de Ama - Marka (ADJ) [Ama] ',
    g3: 'false',
    iata: 'Ásia',
    zone: 'Ásia',
    name: 'Aeroporto Civil de Amã - Marka',
    location: { lon: '36', lat: '32' },
    state: 'Amã',
    international: 'true',
    longitude: '36',
  },
  {
    country: 'França',
    altitude: '290',
    code: 'LAI',
    city: 'Lannion',
    congenere: 'true',
    timezone: 'Europe/Paris',
    latitude: '48.754378',
    active: 'true',
    description: 'Lannion, Franca (LAI) [Lannion] ',
    g3: 'false',
    iata: 'Europa',
    zone: 'Europa',
    name: 'Côte de Granit ',
    location: { lon: '-3.471656', lat: '48.754378' },
    state: null,
    international: 'true',
    longitude: '-3.471656',
  },
  {
    country: 'França',
    altitude: '392',
    code: 'CDG',
    city: 'Paris',
    congenere: 'true',
    timezone: 'Europe/Paris',
    latitude: '49.012779',
    active: 'true',
    description: 'Paris, Franca, Paris-Charles De Gaulle (CDG) [Paris] ',
    g3: 'false',
    mac: 'PAR',
    iata: 'Europa',
    zone: 'Europa',
    name: 'Paris-Charles De Gaulle',
    location: { lon: '2.55', lat: '49.012779' },
    state: null,
    international: 'true',
    longitude: '2.55',
  },
  {
    country: 'México',
    altitude: '69',
    code: 'LAP',
    city: 'La Paz',
    congenere: 'true',
    timezone: 'America/Mazatlan',
    latitude: '24.072694',
    active: 'true',
    description: 'La Paz, Mexico, Manuel Marquez de Leon (LAP) [La Paz] ',
    g3: 'false',
    iata: 'América do Norte',
    zone: 'América do Norte',
    name: 'Manuel Márquez de León',
    location: { lon: '-110.362475', lat: '24.072694' },
    state: null,
    international: 'true',
    longitude: '-110.362475',
  },
  {
    country: 'México',
    altitude: '108',
    code: 'CUL',
    city: 'Culiacan',
    congenere: 'true',
    timezone: 'America/Mazatlan',
    latitude: '24.764547',
    active: 'true',
    description: 'Culiacan, Mexico (CUL) [Culiacan] ',
    g3: 'false',
    iata: 'América do Norte',
    zone: 'América do Norte',
    name: 'Federal de Bachigualato',
    location: { lon: '-107.474717', lat: '24.764547' },
    state: null,
    international: 'true',
    longitude: '-107.474717',
  },
  {
    country: 'México',
    altitude: '30',
    code: 'ZLO',
    city: 'Manzanillo',
    congenere: 'true',
    timezone: 'America/Mexico_City',
    latitude: '19.14478',
    active: 'true',
    description: 'Manzanillo, Mexico, Playa de Oro International Airport (ZLO) [Manzanillo] ',
    g3: 'false',
    iata: 'América do Norte',
    zone: 'América do Norte',
    name: 'Playa de Oro International Airport',
    location: { lon: '-104.55863', lat: '19.14478' },
    state: 'Manzanillo',
    international: 'true',
    longitude: '-104.55863',
  },
  {
    country: 'México',
    altitude: '464',
    code: 'HUX',
    city: 'Huatulco',
    congenere: 'true',
    timezone: 'America/Mexico_City',
    latitude: '15.775317',
    active: 'true',
    description: 'Huatulco, Mexico (HUX) [Huatulco] ',
    g3: 'false',
    iata: 'América do Norte',
    zone: 'América do Norte',
    name: 'Bahías de Huatulco',
    location: { lon: '-96.262572', lat: '15.775317' },
    state: null,
    international: 'true',
    longitude: '-96.262572',
  },
  {
    country: 'Ecuador',
    altitude: '834',
    code: 'OCC',
    city: 'Coca',
    congenere: 'true',
    timezone: 'America/Guayaquil',
    latitude: '0',
    active: 'true',
    description: 'Coca, Ecuador (OCC) [Coca] ',
    g3: 'false',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'Francisco De Orellana',
    location: { lon: '-76', lat: '0' },
    state: null,
    international: 'true',
    longitude: '-76',
  },
  {
    country: 'Venezuela',
    altitude: '25',
    code: 'CUM',
    city: 'Cumana',
    congenere: 'true',
    timezone: 'America/Caracas',
    latitude: '10',
    active: 'true',
    description: 'Cumana, Venezuela (CUM) [Cumana] ',
    g3: 'false',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'Antonio Jose De Sucre',
    location: { lon: '-64', lat: '10' },
    state: null,
    international: 'true',
    longitude: '-64',
  },
  {
    country: 'Bolivia',
    altitude: '9527',
    code: 'SRE',
    city: 'Sucre',
    congenere: 'true',
    timezone: 'America/La_Paz',
    latitude: '-19',
    active: 'true',
    description: 'Sucre, Bolivia (SRE) [Sucre] ',
    g3: 'false',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'Juana Azurduy De Padilla',
    location: { lon: '-65', lat: '-19' },
    state: null,
    international: 'true',
    longitude: '-65',
  },
  {
    country: 'Brasil',
    altitude: '334',
    code: 'BYO',
    city: 'Bonito',
    congenere: 'true',
    timezone: 'America/Campo_Grande',
    latitude: '-21.247221',
    active: 'true',
    description: 'Bonito, Brasil (BYO) [Bonito] ',
    g3: 'true',
    mac: 'BYO',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Aeroporto de Bonito',
    location: { lon: '-56.452499', lat: '-21.247221' },
    state: 'Mato Grosso do Sul',
    international: 'false',
    longitude: '-56.452499',
  },
  {
    country: 'Brasil',
    altitude: '54',
    code: 'BEL',
    city: 'Belém',
    congenere: 'true',
    timezone: 'America/Belem',
    latitude: '-1.37925',
    active: 'true',
    description: 'Belem, Brasil (BEL) [Belem] ',
    g3: 'true',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Val de Cans',
    location: { lon: '-48.476292', lat: '-1.37925' },
    state: 'Pará',
    international: 'true',
    longitude: '-48.476292',
  },
  {
    country: 'Bulgaria',
    altitude: '182',
    code: 'PDV',
    city: '  Bulgaria',
    congenere: 'true',
    timezone: 'undefined/undefined',
    latitude: '42.068',
    active: 'true',
    description: '  Bulgaria, Bulgaria (PDV) [  Bulgaria] ',
    g3: 'false',
    iata: 'Europe/Sofia',
    zone: 'Europa',
    name: '  Aeroporto de Plovdiv Krumovo',
    location: { lon: '24.851', lat: '42.068' },
    state: 'Plovdiv',
    international: 'true',
    longitude: '24.851',
  },
  {
    country: 'Brasil',
    altitude: '11',
    code: 'VIX',
    city: 'Vitória',
    congenere: 'false',
    timezone: 'America/Sao_Paulo',
    latitude: '-20.258056',
    active: 'true',
    description: 'Vitoria, Brasil (VIX) [Vitoria] ',
    g3: 'true',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Eurico de Aguiar Salles',
    location: { lon: '-40.286389', lat: '-20.258056' },
    state: 'Espirito Santo',
    international: 'false',
    longitude: '-40.286389',
  },
  {
    country: 'Argentina',
    altitude: '2776',
    code: 'BRC',
    city: 'Bariloche',
    congenere: 'true',
    timezone: 'America/Argentina/Salta',
    latitude: '-41.151172',
    active: 'true',
    description: 'Bariloche, Argentina (BRC) [Bariloche] ',
    g3: 'true',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'San Carlos de Bariloche',
    location: { lon: '-71.157542', lat: '-41.151172' },
    state: null,
    international: 'true',
    longitude: '-71.157542',
  },
  {
    country: 'Venezuela',
    altitude: '154',
    code: 'SFD',
    city: 'San Fernando Apure',
    congenere: 'true',
    timezone: 'America/Caracas',
    latitude: '7',
    active: 'true',
    description: 'San Fernando Apure, Venezuela (SFD) [San Fernando Apure] ',
    g3: 'false',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'San Fernando De Apure',
    location: { lon: '-67', lat: '7' },
    state: null,
    international: 'true',
    longitude: '-67',
  },
  {
    country: 'Austrália',
    altitude: '20',
    code: 'ADL',
    city: 'Adelaide',
    congenere: 'true',
    timezone: 'Australia/Adelaide',
    latitude: '-35',
    active: 'true',
    description: 'Adelaide, Australia (ADL) [Adelaide] ',
    g3: 'false',
    iata: 'Oceania',
    zone: 'Oceania',
    name: 'Aeroporto Internacional de Adelaide',
    location: { lon: '139', lat: '-35' },
    state: 'Adelaide',
    international: 'true',
    longitude: '139',
  },
  {
    country: 'México',
    altitude: '7.361',
    code: 'PBC',
    city: 'Puebla',
    congenere: 'true',
    timezone: 'America/Mexico_City',
    latitude: '19.15814',
    active: 'true',
    description: 'Puebla, Mexico (PBC) [Puebla] ',
    g3: 'false',
    iata: 'América do Norte',
    zone: 'América do Norte',
    name: 'Aeroporto Internacional de Puebla',
    location: { lon: '-98.37145', lat: '19.15814' },
    state: 'Puebla',
    international: 'true',
    longitude: '-98.37145',
  },
  {
    country: 'Cuba',
    altitude: '203',
    code: 'BYM',
    city: 'Bayamo',
    congenere: 'true',
    timezone: 'America/Havana',
    latitude: '20',
    active: 'true',
    description: 'Bayamo, Cuba (BYM) [Bayamo] ',
    g3: 'false',
    iata: 'América do Norte',
    zone: 'América do Norte',
    name: 'Carlos Manuel De Cespedes',
    location: { lon: '-76', lat: '20' },
    state: null,
    international: 'true',
    longitude: '-76',
  },
  {
    country: 'Argentina',
    altitude: '4088',
    code: 'SLA',
    city: 'Salta',
    congenere: 'true',
    timezone: 'America/Argentina/Salta',
    latitude: '-24.855978',
    active: 'true',
    description: 'Salta, Argentina (SLA) [Salta] ',
    g3: 'false',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'Martín Miguel de Güemes   ',
    location: { lon: '-65.486169', lat: '-24.855978' },
    state: null,
    international: 'true',
    longitude: '-65.486169',
  },
  {
    country: 'Peru',
    altitude: '106',
    code: 'TRU',
    city: 'Trujillo',
    congenere: 'true',
    timezone: 'America/Lima',
    latitude: '-8',
    active: 'true',
    description: 'Trujillo, Peru (TRU) [Trujillo] ',
    g3: 'false',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'Capitan Carlos Martinez De Pinillos',
    location: { lon: '-79', lat: '-8' },
    state: null,
    international: 'true',
    longitude: '-79',
  },
  {
    country: 'Grécia',
    altitude: '115',
    code: 'HER',
    city: 'Heraklion',
    congenere: 'true',
    timezone: 'Europe/Athens',
    latitude: '35.339719',
    active: 'true',
    description: 'Heraklion, Grecia (HER) [Heraklion] ',
    g3: 'false',
    iata: 'Europa',
    zone: 'Europa',
    name: 'Aeroporto Internacional de Heraklion',
    location: { lon: '25.180297', lat: '35.339719' },
    state: null,
    international: 'true',
    longitude: '25.180297',
  },
  {
    country: 'Portugal',
    altitude: '228',
    code: 'OPO',
    city: 'Porto',
    congenere: 'true',
    timezone: 'Europe/Lisbon',
    latitude: '41.248055',
    active: 'true',
    description: 'Porto, Portugal (OPO) [Porto] ',
    g3: 'false',
    iata: 'Europa',
    zone: 'Europa',
    name: 'Francisco de Sá Carneiro',
    location: { lon: '-8.681389', lat: '41.248055' },
    state: null,
    international: 'true',
    longitude: '-8.681389',
  },
  {
    country: 'Brasil',
    altitude: '15',
    code: 'JOI',
    city: 'Joinville',
    congenere: 'false',
    timezone: 'America/Sao_Paulo',
    latitude: '-26.224453',
    active: 'true',
    description: 'Joinville, Brasil (JOI) [Joinville] ',
    g3: 'true',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Lauro Carneiro de Loyola',
    location: { lon: '-48.797364', lat: '-26.224453' },
    state: 'Santa Catarina',
    international: 'false',
    longitude: '-48.797364',
  },
  {
    country: 'Brasil',
    altitude: '1392',
    code: 'JDO',
    city: 'Juazeiro do Norte',
    congenere: 'false',
    timezone: 'America/Fortaleza',
    latitude: '-7.218958',
    active: 'true',
    description: 'Juazeiro do Norte, Brasil (JDO) [Juazeiro do Norte] ',
    g3: 'true',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Orlando Bezerra de Menezes',
    location: { lon: '-39.2701', lat: '-7.218958' },
    state: 'Ceará',
    international: 'false',
    longitude: '-39.2701',
  },
  {
    country: 'Brasil',
    altitude: '294',
    code: 'PVH',
    city: 'Porto Velho',
    congenere: 'false',
    timezone: 'America/Porto_Velho',
    latitude: '-8.709294',
    active: 'true',
    description: 'Porto Velho, Brasil (PVH) [Porto Velho] ',
    g3: 'true',
    iata: 'Brasil',
    zone: 'América do Sul',
    name: 'Governador Jorge Teixeira de Oliveira',
    location: { lon: '-63.902281', lat: '-8.709294' },
    state: 'Rondônia',
    international: 'false',
    longitude: '-63.902281',
  },
  {
    country: 'Equador',
    altitude: '19',
    code: 'GYE',
    city: 'Guaiaquil',
    congenere: 'true',
    timezone: 'America/Guayaquil',
    latitude: '-2.157419',
    active: 'true',
    description: 'Guaiaquil, Equador (GYE) [Guaiaquil] ',
    g3: 'false',
    mac: 'GYE',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'Aeroporto Jose Joaquin De Olmedo',
    location: { lon: '-79.883558', lat: '-2.157419' },
    state: 'Guaiaquil',
    international: 'true',
    longitude: '-79.883558',
  },
  {
    country: 'Argentina',
    altitude: '243',
    code: 'PRA',
    city: 'Paraná',
    congenere: 'true',
    timezone: 'America/Argentina/Cordoba',
    latitude: '-31.794778',
    active: 'true',
    description: 'Parana, Argentina (PRA) [Parana] ',
    g3: 'false',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'General Justo José de Urquiza',
    location: { lon: '-60.480361', lat: '-31.794778' },
    state: null,
    international: 'true',
    longitude: '-60.480361',
  },
  {
    country: 'França',
    altitude: '74',
    code: 'LRH',
    city: 'La Rochelle',
    congenere: 'true',
    timezone: 'Europe/Paris',
    latitude: '46.1792',
    active: 'true',
    description: 'La Rochelle, Franca (LRH) [La Rochelle] ',
    g3: 'false',
    iata: 'Europa',
    zone: 'Europa',
    name: 'La Rochelle - Île de Ré ',
    location: { lon: '-1.19528', lat: '46.1792' },
    state: null,
    international: 'true',
    longitude: '-1.19528',
  },
  {
    country: 'Argentina',
    altitude: '656',
    code: 'SDE',
    city: 'Santiado del Estero',
    congenere: 'true',
    timezone: 'America/Argentina/Cordoba',
    latitude: '-27.765617',
    active: 'true',
    description: 'Santiado del Estero, Argentina (SDE) [Santiado del Estero] ',
    g3: 'false',
    iata: 'América do Sul',
    zone: 'América do Sul',
    name: 'Vicecomodoro Ángel de la Paz Aragonés',
    location: { lon: '-64.310122', lat: '-27.765617' },
    state: null,
    international: 'true',
    longitude: '-64.310122',
  },
];
